import React, {FC} from 'react'
import {Trans, useTranslation} from 'react-i18next'
import {useHistory} from 'react-router-dom'

import {Box, Button, Typography} from '@mui/material'

import {ReactComponent as ExpiredImage} from '@progyny/assets/images/fail-link.svg'
import loginPicPng from '@progyny/assets/images/side-banner-white-top.png'
import {SidepanelContainer} from '@progyny/components/SidepanelContainer'
import SimpleMessageContainer from '@progyny/components/SimpleMessageContainer'
import {RouteEnum, useRoutes} from '@progyny/routes'

import {theme} from '@root/theme'

const PasswordTokenError: FC = () => {
  const history = useHistory()
  const {t} = useTranslation()
  const {getPath} = useRoutes()

  return (
    <SidepanelContainer
      styleProps={{
        backgroundPicSrc: loginPicPng,
        backgroundColor: theme.palette.primary.main,
        logoColor: 'primary',
      }}
      mainComponent={
        <SimpleMessageContainer
          image={ExpiredImage}
          message={
            <Box>
              <Typography variant={'h3'} textAlign={'center'}>
                {t('password_token_error_we_have_feeling_of_dejavu')}
              </Typography>
              <Typography variant={'body1'} mt={2}>
                <Box textAlign={'center'}>
                  <Trans i18nKey='password_token_error_for_your_security_password_reset' />

                  <Box mt={6}>
                    <Button
                      variant='contained'
                      onClick={() => {
                        history.push(getPath(RouteEnum.FORGET_PASSWORD))
                      }}
                      fullWidth
                    >
                      {t('password_token_error_send_new_reset_link')}
                    </Button>
                  </Box>
                </Box>
              </Typography>
            </Box>
          }
        />
      }
    />
  )
}

export default PasswordTokenError
